export const SortDirections = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
} as const;

export type SortDirection =
  (typeof SortDirections)[keyof typeof SortDirections];
